module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACZSURBVDiNrZNdEcQgDISZKqgEpOAQCZGCBCQg5etLmEvT9I5Ob58YsrshP6TkAGRAgM4HA6hA8Xwr3JX0CxXYI3FfEE/0k8li5stLpri4wABaIGgas8hR9qbGYu5E77yxpMDVCsSdPXr6UqOYHkViALbbua7iZnyrJYwo8KSJda7uyfXBGMv7RfrLKr/+TM6oKMnW27Wp2fMPMMD2mVkNn/4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/updel.png
// module id = n/DK
// module chunks = 1